import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExcelService} from "../../../../services/ExcelService";
import { AccessRights, UsersService } from '../../../../services/users.service';
import { PageInfo } from '../../../shared/components/pagination/pagination.component';
import { IManagableObject } from '../../IManagableObject';

@Component({
    selector: 'app-footer-component',
    templateUrl: './footer-component.component.html',
    styleUrls: ['./footer-component.component.css'],
    standalone: false
})
export class FooterComponentComponent implements OnInit {
  @Input() public viewMode: string = 'print excel';
  @Input() public printElementID: string = null;
  @Input() public items: IManagableObject[] = [];

  @Output() onDeleteSelected: EventEmitter<any> = new EventEmitter();
  @Output() onPageChange: EventEmitter<PageInfo> = new EventEmitter();

  public AccessRights = AccessRights;

  constructor(private exportService: ExcelService, private usersService: UsersService) { }

  ngOnInit() {
  }

  public itemsCount(): string {
    if (this.items != null)
      return this.items.filter((item) => item.IsChecked).length.toString();
    return "";
  }

  public canAccessComponent(rights: AccessRights): boolean {
    return this.usersService.IsPermitted(rights);
  }

  public deleteSelected() {
    this.onDeleteSelected.emit();
  }

  public onExport(reportType:string) {
    if (reportType == "pdf") {

    }
    if (reportType == "excel") {
      this.exportToExcel()
    }
  }

  public exportToExcel(){
    let tbl = document.getElementById('exporttable');
    if (!tbl)
      tbl = document.getElementById('trenddesctable');
    this.exportService.exportAsExcelFile(tbl);
  }

  pageChange(pageInfo: PageInfo) {
    this.onPageChange.emit(pageInfo);
  }
}
